import andyLogo from '@/images/clients/andy-logo.jpg'
import { Market } from 'BrokerTsLib/src/enums'
import type { IPartnerSettings } from '.'

export const AndyAuto: IPartnerSettings = {
  partner: 'AndyAuto',
  hosts: [
    'srovnavac.andy-auta.cz',
    //, 'localhost:44470'
  ],
  logo: andyLogo,
  market: Market.CZ
}
